// TIMELINE

$('.button--timeline').click(function (e) {
	e.preventDefault();
	var target = $(this).attr('href');
	$(this).parents('.timeline').find('.button--timeline').removeClass('active');
	$(this).parents('.timeline').find('.timeline__text').removeClass('active');
	//$('.button--timeline').removeClass('active');
	// $('.timeline__text').removeClass('active');
	$(this).addClass('active');
	$(target).addClass('active');
});
